<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'COMPANY_PROFILE.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'ADMINISTRATION.PAGE_TITLE' | translate"
        [previousPageUrl]="'/settings'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <div class="card-wrapper">
    <mat-card appearance="outlined" class="company-card">
      @if (partnerMailingAddressInfo$ | async) {
        <mat-card-content>
          <form [formGroup]="updateCompanyFormGroup">
            <glxy-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls.company_name"
              [label]="'COMPANY_PROFILE.COMPANY_NAME' | translate"
              [required]="true"
            ></glxy-input>
            <glxy-phone-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls.phone_number"
              [placeholder]="'COMPANY_PROFILE.PHONE_NUMBER' | translate"
              [required]="false"
            ></glxy-phone-input>
            <glxy-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls.website_address"
              [label]="'COMPANY_PROFILE.WEBSITE_URL' | translate"
              [required]="false"
            ></glxy-input>
            <glxy-email-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls.email_address"
              [placeholder]="'COMPANY_PROFILE.EMAIL_ADDRESS' | translate"
              [required]="false"
            ></glxy-email-input>
            <!-- ADDRESS SECTION -->
            <div class="address-section-title">
              <strong>
                {{ 'COMPANY_PROFILE.ADDRESS_TITLE' | translate }}
              </strong>
            </div>
            @if (countryOptions$ && (countryOptions$ | async)?.length > 0) {
              <glxy-select-input
                class="form-input"
                [formControl]="updateCompanyFormGroup.controls['country']"
                [label]="'COMMON.ADDRESS.COUNTRY'"
                [options]="countryOptions$ | async"
                [required]="true"
              ></glxy-select-input>
            }
            <glxy-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls['address']"
              [label]="'COMMON.ADDRESS.LINE_1'"
              [required]="true"
            ></glxy-input>
            <glxy-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls['additionalAddressLine']"
              [label]="'COMMON.ADDRESS.LINE_2'"
            ></glxy-input>
            @if ((stateProvOptions$$ | async)?.length > 0) {
              <glxy-select-input
                class="form-input"
                [formControl]="updateCompanyFormGroup.controls['stateProv']"
                [label]="'COMMON.ADDRESS.STATE_PROV'"
                [options]="stateProvOptions$$ | async"
                [required]="true"
              ></glxy-select-input>
            }
            <glxy-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls['city']"
              [label]="'COMMON.ADDRESS.CITY'"
              [required]="true"
            ></glxy-input>
            <glxy-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls['postalCode']"
              [label]="'COMMON.ADDRESS.POSTAL_CODE'"
              [required]="true"
            ></glxy-input>
          </form>
          <!-- END ADDRESS SECTION -->
        </mat-card-content>
      } @else {
        <div class="loading-page-spinner">
          <mat-spinner diameter="45"></mat-spinner>
        </div>
      }
      <mat-card-actions>
        <button mat-flat-button color="primary" (click)="updateCompanyProfile()" [disabled]="isUpdatingProfile">
          @if (!isUpdatingProfile) {
            {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
          } @else {
            <div class="loading-spinner">
              <mat-spinner diameter="36"></mat-spinner>
            </div>
          }
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</glxy-page>
